// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import AlertController from "./alert_controller"
import SmsController from "./sms_controller"
import TimeagoController from "./timeago_controller"

application.register("timeago", TimeagoController)
application.register("alert", AlertController)
application.register("hello", HelloController)
application.register("sms", SmsController)
